"use client";

import { UiModal } from "@frontend/roz-uikit";

import { useModalStore } from "@/ui-state";
import { PersonalData } from "../components/personal-data";
import { ThirdParty } from "../components/third-party";
import {
  canCloseByType,
  classNameByType,
  closeButtonByType,
} from "./modal-helpers";

export const Modal = () => {
  const { isOpen, type } = useModalStore();

  const renderContent = () => {
    switch (type) {
      case "third-party": {
        return <ThirdParty />;
      }

      case "personal-data": {
        return <PersonalData />;
      }

      default: {
        break;
      }
    }
  };

  return (
    <UiModal
      className={classNameByType(type)}
      customCloseButton={closeButtonByType(type)}
      onClose={canCloseByType(type)}
      open={isOpen}
    >
      {renderContent()}
    </UiModal>
  );
};
